<template>
  <!--
    	作者：luoyiming
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form
      size="small"
      ref="dataForm"
      :rules="rules"
      :model="form"
      label-width="120px"
    >
      <!--添加门店-->
      <div class="common-form">手办</div>

      <el-form-item label="手办名称" prop="card_name">
        <el-input
          v-model="form.card_name"
          placeholder="请输入手办名称"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item label="手办排序">
        <el-input
          type="number"
          v-model="form.sort"
          placeholder="请输入序号"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item label="手办图片" prop="image_id">
        <el-row>
          <el-button
            icon="el-icon-picture-outline"
            @click="
              () => {
                this.uploadType = '';
                openUpload();
              }
            "
            >选择图片</el-button
          >
          <div v-if="form.image_id != ''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="手办剪影图片" prop="bg_image_id">
        <el-row>
          <el-button
            icon="el-icon-picture-outline"
            @click="
              () => {
                this.uploadType = 'bg';
                openUpload();
              }
            "
            >选择图片</el-button
          >
          <div v-if="form.bg_image_id != ''" class="img">
            <img :src="bg_file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="所属分类：" prop="category_id">
        <el-select v-model="form.category_id" @change="getChildCategory">
          <el-option
            v-for="item in category"
            :key="item.category_id"
            :label="item.name"
            :value="item.category_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="所属二级分类：" prop="child_category_id">
        <el-select v-model="form.child_category_id">
          <el-option
            v-for="item in child_category"
            :key="item.category_id"
            :label="item.name"
            :value="item.category_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="是否是隐藏款" prop="is_hidden_item">
        <el-switch type="number" v-model="form.is_hidden_item" />
      </el-form-item>
      <el-form-item label="概率" prop="probability">
        <el-input type="number" v-model="form.probability" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="手办类型" prop="card_type">
        <el-input
          v-model="form.card_type"
          placeholder="请输入手办类型"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <el-form-item label="商品" prop="product">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="changeProduct"
          v-auth="'/plus/points/product/add'"
          >选择商品</el-button
        >
      </el-form-item>
      <!--商品信息-->
      <Info v-if="form.product_id != 0"></Info>
      <!-- <el-form-item v-if="form.product_id != 0" label="抽奖数量" prop="number">
        <el-input type="number" v-model="form.number" placeholder="请输入抽奖数量" class="max-w460"></el-input>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSubmit('dataForm')"
          :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>
    <!--商品选择-->
    <Product
      :isproduct="isproduct"
      :productType="productType"
      :excludeIds="exclude_ids"
      :islist="false"
      @closeDialog="closeProductFunc"
    ></Product>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </div>
</template>

<script>
import PointProductApi from "@/api/pointproduct.js";
import codeApi from "@/api/code.js";
import Upload from "@/components/file/Upload";
import Product from "@/components/product/Product.vue";
import Info from "@/views/appsetting/cdk/product/info.vue";
export default {
  components: {
    /*产品基本信息*/
    Info,
    Upload,
    /*选择商品*/
    Product,
  },
  data() {
    var probabilityValidator = (rule, value, callback) => {
      var reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (value > 0 && value <= 100 && reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入大于零小于一百不超过二位小数的数字"));
      }
    };
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        image_id: "",
        bg_image_id: "",
        is_hidden_item: 0,
        card_id: "",
        category_id: "",
        card_name: "",
        sort: 0,
        card_type: "",
        child_category_id: "",
        /*商品名称*/
        product_name: "",
        /*商品ID*/
        product_id: 0,
        product_image: "",
        spec_sku_id: "",
        number: 0,
        probability: 0,
      },

      category: [],
      child_category: [],
      file_path: "",
      bg_file_path: "",
      /*是否上传图片*/
      isupload: false,
      loading: false,
      /*是否打开选择商品*/
      isproduct: false,
      productType: "noRecover1y",
      /*已有的id*/
      exclude_ids: [],
      product_sku: [],
      rules: {
        card_name: [{ required: true, message: "请填写手办名称" }],
        image_id: [{ required: true, message: "请选择手办图片" }],
        bg_image_id: [{ required: true, message: "请选择手办剪影图片" }],
        is_hidden_item: [{ required: true, message: "是否是隐藏款" }],
        category_id: [{ required: true, message: "请选择所属分类" }],
        card_type: [{ required: true, message: "请选择商品手办类型" }],
        probability: [
          { required: true, message: "请填写概率", trigger: "blur" },
          { required: true, validator: probabilityValidator, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    /*引用的select_region 初始化*/
    this.uploadType = "";
    this.getFenlei();
  },
  provide: function () {
    return {
      form: this.form,
      product_sku: () => this.product_sku,
      type: "add",
    };
  },
  methods: {
    // 分类
    getChildCategory() {
      let self = this;
      codeApi
        .cardType({ parent_id: this.form.category_id }, true)
        .then((res) => {
          self.child_category = res.data.list;
        })
        .catch((error) => {});
    },
    getFenlei() {
      let self = this;
      codeApi
        .cardType({ parent_id: 0 }, true)
        .then((res) => {
          self.category = res.data.list;
        })
        .catch((error) => {});
    },
    getData() {
      let self = this;
      StoreApi.toAddShop({}, true)
        .then((res) => {
          self.areaList = res.data.regionData;
        })
        .catch((error) => {});
    },

    /*获取商品*/
    getProductData() {
      let self = this;
      PointProductApi.getProduct(
        {
          product_id: self.form.product_id,
        },
        true
      ).then((res) => {
        // Object.assign(self.form, res.data.model);
        self.form.product_name = res.data.model.product_name;
        self.form.product_image = res.data.model.product_image;
        var sku = [];
        res.data.model.sku.forEach((item, index) => {
          sku.push({
            key: index,
            label: item.spec_sku_id,
            value: item.spec_sku_id,
            stock_num: item.stock_num,
          });
        });
        this.product_sku = sku;
        if (this.product_sku.length > 0) {
          self.form.spec_sku_id = this.product_sku[0].value;
        }
        self.loading = false;
      });
    },
    /*添加用户*/
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let self = this;
          let form = self.form;
          self.loading = true;
          codeApi
            .cardAdd(form, true)
            .then((data) => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，添加成功",
                  type: "success",
                });
                self.$router.push("/card/card/index");
              } else {
                self.loading = false;
              }
            })
            .catch((error) => {
              self.loading = false;
            });
        } else {
          this.$message.error("请完善必填信息");
          return false;
        }
      });
    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.uploadType === "bg") {
          this.bg_file_path = e[0].file_path;
          this.form.bg_image_id = e[0].file_id;
        } else {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
      }
      this.isupload = false;
    },

    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == "success") {
        this.addClick(e.params.product_id);
      } else {
        this.form.product_id = 0;
        this.form.product_name = "";
        this.form.spec_sku_id = 0;
      }
    },

    /*添加商品*/
    addClick(product_id) {
      // this.$router.push('/appsetting/cdk/add?product_id=' + product_id);
      this.form.product_id = product_id;
      this.getProductData();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/card/card/add.vue